export const hospitalPostedChargesColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'amount',
  'billing_physician__code',
  'billing_physician__name',
  'billing_physician__npi',
  'billing_physician__specialty',
  'cdm__cdm_description',
  'cdm__cdm_number',
  'cpt',
  'department_code',
  'department_name',
  'dosage_amount',
  'dosage_unit_of_measure',
  'fk_hospital__data_doc_new_id',
  'formulary_description',
  'hcpcs',
  'is_duplicate_cpt',
  'is_reversed_charge',
  'is_scrubbed',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'modifier1',
  'modifier2',
  'modifier3',
  'modifier4',
  'ndc',
  'performing_physician__code',
  'performing_physician__name',
  'performing_physician__npi',
  'performing_physician__specialty',
  'posting_date',
  'quantity',
  'revenue_code',
  'service_date',
  'snapshot_id',
  'system_id',
  'transaction_id',
  'visit_transaction_return_identifier1',
  'visit_transaction_return_identifier2',
  'visit_transaction_return_identifier3',
];
